var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('interview-action-enter', _vm._b({
    attrs: {
      "componentIs": "v-sheet",
      "max-width": "720"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var enter = _ref.enter,
          loading = _ref.loading,
          errorMessages = _ref.errorMessages;
        return [_vm.mode == 'view' ? _c('p', {
          staticClass: "font-size-14 grey--text text--lighten-2"
        }, [_vm._v(" 마이스팩의 비대면 면접 솔루션입니다. "), _c('br'), _vm._v(" 참여코드를 입력 후 면접에 참여하거나 알림톡의 url 을 통해서 비대면 면접을 진행해주세요. "), _c('br')]) : _vm._e(), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm.mode == 'view' ? _c('span', {
          staticClass: "d-inline-block font-weight-bold mt-12"
        }, [_vm._v(" 참여코드 입력 후 면접 참여 ")]) : _vm._e(), _c('v-text-field', _vm._b({
          ref: "code-input",
          on: {
            "input": _vm.onCodeInput,
            "keydown": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return enter.apply(null, arguments);
            }
          },
          scopedSlots: _vm._u([{
            key: "append-outer",
            fn: function () {
              return [_c('v-btn', _vm._b({
                staticClass: "mt-n8",
                attrs: {
                  "color": "primary"
                },
                on: {
                  "click": enter
                }
              }, 'v-btn', {
                disabled: _vm.disabled,
                loading
              }, false), [_vm._v(" 참여하기 ")])];
            },
            proxy: true
          }], null, true),
          model: {
            value: _vm.code,
            callback: function ($$v) {
              _vm.code = $$v;
            },
            expression: "code"
          }
        }, 'v-text-field', Object.assign({}, _vm.attrs_input, {
          errorMessages,
          hideDetails: 'auto',
          placeholder: '참여코드',
          clearable: true,
          class: {
            'mt-12': _vm.mode == 'view'
          },
          style: {
            maxWidth: '320px'
          }
        }), false))], 1), _vm.$scopedSlots['create'] ? [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_vm.mode == 'view' ? _c('span', {
          staticClass: "d-inline-block font-weight-bold mt-12"
        }, [_vm._v(" 면접 생성하기 ")]) : _vm._e(), _vm._t("create", null, null, {
          loading
        })], 2)] : _vm._e()], 2)];
      }
    }], null, true)
  }, 'interview-action-enter', {
    code: _vm.code,
    onError: _vm.onError
  }, false));

}
var staticRenderFns = []

export { render, staticRenderFns }